import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { CloseIcon, ColoredMoveIcon } from 'ui-component/custom-icons/icons'

import Select from 'react-select';
import { Skeleton } from '@mui/material';
import { toast } from 'react-hot-toast';
import { FaSpinner } from 'react-icons/fa';

// ✅ Clear
const SalesOrderReservationModal = ({
    openPopup,
    salesOrderId,
    name,
    productId,
    colorId,
    backOrderId,
    colorName,
    quantity,
    handleClose,
    handleLoadSalesOrder
}) => {

    const [dataLists, setDataLists] = useState([]);
    const [isFormDisabled, setIsFormDisabled] = useState(false);
    const [selectedQuantity, setSelectedQuantity] = useState(quantity);
    const [selectedProductStockId, setSelectedProductStockId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    

    useEffect(() => {
        initializeItems()
    }, []);
    
    const initializeItems = () => {
        api.getSelectOptionsListWithId('products_with_stocks', productId).then((res) => {
            if (res?.status) {
                const tempList = res?.data?.map((item) => ({
                    ...item,
                    label: `${item.option_label_name}`,
                    value: item.id,
                }));
                setDataLists(tempList);
                setIsLoading(false)
            }
        });

    }


    const submitForm = () => {
        if (!selectedProductStockId) {
            toast.error('Please select a stock item');
            return;
        } else if (selectedQuantity < 1) {
            toast.error('Please enter a valid quantity');
            return;
        }
        const request = {
            sales_order_id: salesOrderId,
            product_stock_id: selectedProductStockId,
            quantity: selectedQuantity,
            backorder_id: backOrderId
        }
        setIsFormDisabled(true)
        toast.promise(
            api
                .createReservationFromSalesOrder(salesOrderId, request)
                .then(
                    (res) => {
                        setIsFormDisabled(false)
                        if (res.status) {
                            handleLoadSalesOrder()
                        }
    
                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Creating Reservation...',
                success: (data) => `${data.message}`,
                error: <b>Failed to create reservation</b>
            }
        );
    }


    return (
        <Modal show={openPopup}  centered size="sm">
            <Modal.Body>
                <div className="p-2">
                    <div>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <ColoredMoveIcon height={'60px'} width={'60px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top">
                            <div className="col-12 text-center " style={{ padding: '10px 0 10px 0' }}>
                                <div style={{ fontSize: '24px' }}>
                                    Reservation
                                </div>
                                <div className="text-gray-800">
                                    Manage reservation quantity for this order
                                </div>
                                
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left " style={{ padding: '10px 0' }}>
                                <label>{name} { colorName }</label>
                                {
                                    isLoading ? (
                                        <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                    ) : (
                                        <Select
                                            options={dataLists}
                                            className={`rs-container ${isFormDisabled ? 'disabled' : ''}`}
                                            classNamePrefix="rs"
                                            placeholder="Select or type..."
                                            isMulti={false}
                                            value={dataLists.find(item => item.value === selectedProductStockId) || null}
                                            formatOptionLabel={({ label, optionAttribute }) => (
                                                <div dangerouslySetInnerHTML={{ __html: label }}></div>
                                            )}
                                            onChange={(e) => {
                                                if (e?.available_stock < 1) {
                                                    toast.error('Selected stock has no available quantity');
                                                } else {
                                                    setSelectedProductStockId(e?.value);
                                                    setSelectedQuantity(e?.available_stock < quantity ? e?.available_stock : quantity);
                                                }
                                            }}
                                            disabled={isFormDisabled}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left " style={{ padding: '10px 0' }}>
                                <label>Quantity to reserve</label>
                                
                                {
                                    isLoading ? (
                                        <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                    ) : (
                                        <input
                                            type="number"
                                            className={`form-control ${(isFormDisabled || !selectedProductStockId) ? 'disabled' : ''}`}
                                            min={1}
                                            max={selectedQuantity}
                                            value={selectedQuantity}
                                            defaultValue={quantity}
                                            disabled={selectedProductStockId ? false : true}
                                            onChange={(e) => {
                                                let val = Number(e.target.value);
                                                if (val > selectedQuantity) {
                                                    setSelectedQuantity(selectedQuantity);
                                                } else if (val < 1) {
                                                    setSelectedQuantity(1);
                                                } else {
                                                    setSelectedQuantity(val);
                                                }
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left " style={{ padding: '20px 0px 0px 0px' }}>
                                
                                <button
                                    className={`${(isFormDisabled || isLoading) && 'disabled' } btn btn-block btn-main-primary btn-outlined-main-primary`}
                                    disabled={isFormDisabled || isLoading}
                                    onClick={() => {
                                        if (!isFormDisabled && !isLoading) {
                                            submitForm()
                                        }
                                    }}
                                >
                                    {
                                        isFormDisabled ? (
                                            <>
                                                <FaSpinner className="fa-spin" /> Processing...
                                            </>
                                        ) : (
                                            'Proceed'
                                        )
                                    }
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SalesOrderReservationModal;
